








































import { Component, Vue } from 'vue-property-decorator';
import { ALL_PENSION_UNIT_SELECTIONS } from '@/queries/PensionUnitSelection';
import PensionUnitSelectionNewButton from '@/components/PensionUnitSelection/PensionUnitSelectionNewButton.vue';
import PensionUnitSelectionShowButton from '@/components/PensionUnitSelection/PensionUnitSelectionShowButton.vue';
import PensionUnitSelectionEditButton from '@/components/PensionUnitSelection/PensionUnitSelectionEditButton.vue';

@Component({
  components: {
    PensionUnitSelectionShowButton,
    PensionUnitSelectionEditButton,
    PensionUnitSelectionNewButton,
  },
})
export default class PensionUnitSelectionList extends Vue {
  private ALL_PENSION_UNIT_SELECTIONS = ALL_PENSION_UNIT_SELECTIONS;
}
